export default __webpack_public_path__ + "static/media/163.44330919.png";